export const MODEL_MANAGEMENT_CONTROLLER_END_POINTS = {
  CONTROLLER_PATH: "model-management",
  GET_ACCESS_TOKEN: "/api/viewables/token",
  PROJECTS: "/api/projects",
  MODELS: "/api/models",
};
